module.exports = __webpack_public_path__ + "assets/blue_angle-arrow-down.3da07e4e.svg";